export const PAGE_VIEW_COOKIE_NAME = 'algolia_search_page_view_count';
export const SUPRESS_FEEDBACK_POPOUT_COOKIE_NAME = 'algolia_search_supress_feedback_popout';
